import Fetch from 'jsx/common/util/_fetch';

export const createConfig = async (config: {}) => {
  return Fetch.put(
    '/api/applications/assetmanagement/isae/create_configuration/',
    {
      body: JSON.stringify(config),
    }
  );
};
